export default __webpack_public_path__ + "static/Atacadao-280313aaac502c24bd4f4942c2adba92.png";